import type { IscEnrollmentStatusDto } from '../../data-transfer-objects';

/**
 * Event types for ISC enrollment gate updates pushed to Care Portal.
 */
export enum IscEnrollmentWSEvents {
  STATUS_UPDATED = '[ISC Enrollment] Status Updated',
}

/**
 * Payload for {@link IscEnrollmentStatusUpdatedWSMessage}.
 */
export interface IscEnrollmentStatusUpdatedWSPayload {
  enrollmentStatus: IscEnrollmentStatusDto;
}

/**
 * Socket.IO event: ISC enrollment gates changed for a member (projection sync).
 */
export class IscEnrollmentStatusUpdatedWSMessage {
  type: string;
  /**
   * @param payload - Latest enrollment gate DTO for the member
   */
  constructor(public payload: IscEnrollmentStatusUpdatedWSPayload) {
    this.type = IscEnrollmentWSEvents.STATUS_UPDATED;
  }
}
